export default __webpack_public_path__ + "static/media/slide_arrow_prev_round.3f593adf.svg";